const titles = {
  manager: {
    attendances: 'Attendances',
    audit: 'Audit',
    availabilities: 'Availabilities',
    bulletins: 'Bulletins',
    contactLists: 'Contact lists',
    punchCards: 'Punch cards',
    projects: 'Projects',
    schedule: 'Schedule',
    scheduleTemplates: 'Schedule templates',
    timeOffs: 'Time offs',
    reportsList: 'Reports List',
    userlist: 'Users List',
    dashboard: 'Dashboard',
    users: 'Users'
  },
  employee: {
    home: 'My Home',
    attendances: 'My attendances',
    attendance: 'My attendance',
    schedule: 'My schedule',
    timeoffs: 'My time offs',
    timeoff: 'My time off',
    messages: 'My messages',
    availabilities: 'My availabilities',
    availability: 'My availability',
    settings: 'My settings',
    shiftOffers: 'My shift offers',
    profile: 'My profile',
    notifications: 'My notifications',
    notFound: 'Not found'
  },
  admin: {
    settings: 'Application settings',
    defaultConfig: 'Default filters',
    defaultFilterConfig: 'Filters',
    listConfig: 'Types of lists',
    permissions: 'Permissions',
    procedureConfig: 'List procedures',
    sortConfig: 'Sorting orders',
    breaks: 'Breaks',
    wagePremiums: 'Wage premiums',
    punchRules: 'Punch rules',
    requestOptions: 'Request Options',
    positions: 'Positions',
    structures: 'Structure',
    scheduleTypes: 'Schedule types',
    tags: 'Tags',
    holidays: 'Holidays',
    attributes: 'Attributes',
    hiringData: 'Hiring data',
    teams: 'Teams',
    departments: 'Departments'
  }
}

export default titles
